export default __webpack_public_path__ + "static/media/10_3.b0e280de.png";